// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"be4ba46a","258":"12406032","276":"01d86f92","338":"6075ff75","496":"873d80c9"}[chunkId] + ".chunk.js";
};